import { default as axios } from "axios";
import config from "../config";
import AuthError from "../Errors/AuthError";
import Error4xx from "../Errors/Error4xx";
import Error5xx from "../Errors/Error5xx";

const apiKey = process.env.REACT_APP_API_KEY;
const apiStage = process.env.REACT_APP_API_STAGE;
const client = axios.create({
    baseURL: `${config["ApiClient"]["baseUrl"]}/${apiStage}`,
    timeout: config["ApiClient"]["timeout"],
    headers: {
        "x-api-key": apiKey,
    },
});

export async function doSolanaAuth(solanaPubKey, signature, messageId) {
    try {
        const response = await client.post("/auth", {
            solanaPubKey,
            signature,
            messageId,
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            if (error.response.status < 500) {
                throw new Error4xx(error.response.data.message);
            } else {
                throw new Error5xx(error.response.data.message);
            }
        } else {
            throw error;
        }
    }
}

export async function doPolygonAuth(jwt, polygonPubKey, signature, messageId) {
    try {
        await client.post(
            "/polygon",
            {
                messageId,
                signature,
                polygonPubKey,
            },
            {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                },
            }
        );
        return true;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) {
                throw new AuthError(error.response.data.message);
            } else if (error.response.status < 500) {
                throw new Error4xx(error.response.data.message);
            } else {
                throw new Error5xx(error.response.data.message);
            }
        } else {
            throw error;
        }
    }
}

export async function saveSwappingRecords(jwt, polygonPubKey, nftTokenAddrs) {
    try {
        const response = await client.post(
            "/records",
            {
                polygonPubKey,
                nftTokenAddrs,
            },
            {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) {
                throw new AuthError(error.response.data.message);
            } else if (error.response.status < 500) {
                throw new Error4xx(error.response.data.message);
            } else {
                throw new Error5xx(error.response.data.message);
            }
        } else {
            throw error;
        }
    }
}

export async function updateSwappingRecords(
    jwt,
    recordGroupId,
    nftTokenAddrTxSigs,
    failedNftTokenAddrTxSigs
) {
    try {
        await client.put(
            "/records",
            {
                recordGroupId,
                nftTokenAddrTxSigs,
                failedNftTokenAddrTxSigs,
            },
            {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                },
            }
        );
        return true;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) {
                throw new AuthError(error.response.data.message);
            } else if (error.response.status < 500) {
                throw new Error4xx(error.response.data.message);
            } else {
                throw new Error5xx(error.response.data.message);
            }
        } else {
            throw error;
        }
    }
}

export async function getRecords(jwt, lastRecordLabel = null, limit = 100) {
    try {
        const response = await client.get("/records", {
            headers: {
                Authorization: `Bearer ${jwt}`,
            },
            params: {
                lastRecordLabel,
                limit,
            },
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 401) {
                throw new AuthError(error.response.data.message);
            } else if (error.response.status < 500) {
                throw new Error4xx(error.response.data.message);
            } else {
                throw new Error5xx(error.response.data.message);
            }
        } else {
            throw error;
        }
    }
}
